import SpecialtyGroupExceptionEditor from "@app/projects/network-assessment/SpecialtyGroupExceptionEditor";
import { FC, useContext, useMemo } from "react";
import { ZipProjectContext } from "./ZipProjectContext";
import { ZipCodeDisplayModel } from "./interfaces/zipCodeDisplayModel";
import { RegionGranularity } from "@app/region-sets/regionSet";
import { RegionSetStatusType } from "@app/projects/enumerators";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";

export const ZipProjectExceptions: FC = () => {
  const projectContext = useContext(ZipProjectContext);
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);
  const { state } = projectContext;

  const regionSetSpecialtyGroupParts = useMemo(() => {
    return state.regionSetSpecialtyGroupToPartsLookup[(state.zipDetails[0] as ZipCodeDisplayModel)?.regionSetSpecialtyGroupId];
  }, [state.regionSetSpecialtyGroupToPartsLookup, state.zipDetails]);

  if (!enabledFeatureFlags.has(Features.ZIP_EXCEPTIONS)) {
    return null;
  }

  const zipDetail = state.zipDetails[0] as ZipCodeDisplayModel;
  const specialtyGroupDescription = (state.zipDetails as ZipCodeDisplayModel[]).find((z) => z.specialtyGroupCode === state.filterSelections.specialtyGroupCode?.key)?.specialtyGroupDescription;

  return (
    <SpecialtyGroupExceptionEditor
      customProjectId={state.project.projectId}
      editEnabled={state.runConfiguration.isLatestPublished && !state.runConfiguration.isProjected && !state.runConfiguration.isTermed && !state.runConfiguration.isProjectedTermed && !state.project.isEditRestricted && !state.project.isReadOnly}
      region={{
        canonicalRegionSetId: null,
        displayName: `${zipDetail.county} (${zipDetail.zipCode})`,
        regionCode: zipDetail.zipCode,
        regionGranularity: RegionGranularity.Zip,
        regionSetId: zipDetail.regionSetId,
        regionStatus: RegionSetStatusType.Active,
        subRegionCode: null,
        subRegions: [],
      }}
      specialtyGroupCode={regionSetSpecialtyGroupParts.specialtyGroupCode}
      specialtyGroupName={specialtyGroupDescription ? `${regionSetSpecialtyGroupParts.specialtyGroupCode} – ${specialtyGroupDescription}` : specialtyGroupDescription}
      exception={(state.specialtyExceptionsMap.get(state.runConfiguration.projectRunConfigurationId) ?? {})[`${regionSetSpecialtyGroupParts.regionSetId}:${regionSetSpecialtyGroupParts.specialtyGroupCode}`]}
      onSubmit={projectContext.onSubmitSpecialtyException}
    />
  );
};
